import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { UserService } from '../../../shared-components/user/user.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoginSettings } from '../LoginSetting.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isValidEmail } from '../change-password/password-validator';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.css']
})
export class ForgotUsernameComponent implements OnInit {
  LoginSettings: LoginSettings;
  forgotUserName: any = {};
  forgotUserNameForm: FormGroup;
  duplicateRecords = false;
  firstNameError = 'Required Field';
  lastNameError = 'Required Field';
  emailAddressError = 'Required Field';
  userType: number;

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private dialogRef: MatDialogRef<ForgotUsernameComponent>,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.LoginSettings = this.loginService.LoginSettings;
    this.forgotUserNameForm = new FormGroup({
      'firstName': new FormControl(null, [
        Validators.required
      ]),
      'lastName': new FormControl(null, [
        Validators.required
      ]),
      'emailAddress': new FormControl(null, [
        Validators.required,
        isValidEmail()
      ])
    });
    this.OnChanges();
  }

  modalInstanceContinueClick() {
    this.firstName.markAsTouched();
    this.lastName.markAsTouched();
    this.emailAddress.markAsTouched();
    this.forgotUserName.firstName = this.firstName.value;
    this.forgotUserName.lastName = this.lastName.value;
    this.forgotUserName.emailAddress = this.emailAddress.value;
    if (this.forgotUserNameForm.valid) {
      this.loginService.sendForgetUserNameEmail(this.forgotUserName.firstName, this.forgotUserName.lastName, this.forgotUserName.emailAddress, this.userType).subscribe(response => {
        if (response.includes('Id=') || response.includes('User not found')) {
          this.dialogRef.close({ isEmailSent: true });
          this.dialog.open(ConfirmationModalComponent, {
            maxWidth: '400px',
            disableClose: true
          });
        }
        if (response.includes('Duplicate Accounts')) {
          this.duplicateRecords = true;
        }
      });
    }
  }

  modalInstanceCancelClick() {
    this.dialogRef.close({ isEmailSent: this.forgotUserName.isEmailSent });
  }

  OnChanges(): void {
    this.forgotUserNameForm.valueChanges.subscribe(val => {
      // Check First Name
      if (this.firstName.invalid) {
        if (this.firstName.errors.hasOwnProperty('required')) {
          this.firstNameError = 'Required Field';
        }
      }
      // Check Last Name
      if (this.lastName.invalid) {
        if (this.lastName.errors.hasOwnProperty('required')) {
          this.lastNameError = 'Required Field';
        }
      }
      // Check Email address
      if (this.emailAddress.invalid) {
        if (this.emailAddress.errors.hasOwnProperty('required')) {
          this.emailAddressError = 'Required Field';
        } else if (this.emailAddress.errors.hasOwnProperty('notValidEmail')) {
          this.emailAddressError = 'Email Address is invalid';
        }
      }
    });
  }

  saveUserLoginInfo(userId: number) {
    this.loginService.saveUserLoginInfo(userId, this.userType, window.innerHeight, window.innerWidth, 4, '');
  }

  get firstName() {
    return this.forgotUserNameForm.get('firstName');
  }

  get lastName() {
    return this.forgotUserNameForm.get('lastName');
  }

  get emailAddress() {
    return this.forgotUserNameForm.get('emailAddress');
  }
}
